"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeLinkSchemaPropTypes = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var makeLinkSchemaPropTypes = function makeLinkSchemaPropTypes() {
  return {
    disabled: _reactDesc.PropTypes.bool.description('Disables the link if true.').defaultValue('false'),
    to: _reactDesc.PropTypes.string.description('Where to navigate when the link is clicked.').isRequired,
    text: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.node]).description("The link's inline text content. Required if no icon is provided."),
    size: _reactDesc.PropTypes.oneOf(['small', 'medium']).description("The size in which to render the link's text and icon").defaultValue('medium'),
    icon: _reactDesc.PropTypes.element.description('Which `iconix` icon to render.'),
    iconPosition: _reactDesc.PropTypes.oneOf(['left', 'right']).description('In which side of the text the icon should be rendered.').defaultValue('left'),
    variant: _reactDesc.PropTypes.oneOf(['normal', 'inverted']).description('Which link variant to render.').defaultValue('normal')
  };
};

exports.makeLinkSchemaPropTypes = makeLinkSchemaPropTypes;
var schema = (0, _reactDesc.describe)({
  displayName: 'Link'
});
schema.propTypes = makeLinkSchemaPropTypes();
var _default = schema;
exports.default = _default;